/* eslint-disable no-restricted-syntax */
import { getCarrier } from '@sell/utils';
import type { PortfolioItem } from '@app/types';
import { TFunction } from 'i18next';
import { addDays, isDatePassed } from '@app/datetime';

export const states = {
  STATE_INVALID: {
    val: 0,
    front: 'portfolio_item_state_0',
    match: '',
  },
  STATE_REMOVED: {
    val: 50,
    front: 'portfolio_item_state_50',
    match: '',
  },
  STATE_HOLDING: {
    val: 100,
    front: 'portfolio_item_state_100',
    match: '',
  },
  STATE_WANTING: {
    val: 200,
    front: 'portfolio_item_state_200',
    match: '',
  },
  STATE_BIDDING: {
    val: 300,
    front: 'portfolio_item_state_300',
    match: '',
  },
  STATE_BID_MATCHED_ASK: {
    val: 310,
    front: 'portfolio_item_state_310',
    match: '',
  },
  STATE_BID_PAID: {
    val: 320,
    front: 'portfolio_item_state_320',
    match: '',
  },
  STATE_BID_FOR_INVENTORY: {
    val: 321,
    front: 'portfolio_item_state_321',
    match: '',
  },
  STATE_BID_AUTHENTICATED: {
    val: 325,
    front: 'portfolio_item_state_325',
    match: '',
  },
  STATE_BID_PAYMENT_FAILED: {
    val: 330,
    front: 'portfolio_item_state_330',
    match: '',
  },
  STATE_BID_PICKUP: {
    val: 335,
    front: 'portfolio_item_state_335',
    match: '',
  },
  STATE_BID_STAGED_TO_SHIP: {
    val: 339,
    front: 'portfolio_item_state_339',
    match: '',
  },
  STATE_BID_SHIPPED_TO_BUYER: {
    val: 340,
    front: 'portfolio_item_state_340',
    match: '',
  },
  STATE_BID_SHIPMENT_RECALLED: {
    val: 341,
    front: 'portfolio_item_state_341',
    match: '',
  },
  STATE_BID_COMPLETE: {
    val: 350,
    front: 'portfolio_item_state_350',
    match: '',
  },
  STATE_BID_DONATION_ACCEPTED: {
    val: 370,
    front: 'portfolio_item_state_370',
    match: '',
  },
  STATE_BID_RETURN_GENERATED: {
    val: 380,
    front: 'portfolio_item_state_380',
    match: '',
  },
  STATE_BID_RETURN_SHIPPED: {
    val: 381,
    front: 'portfolio_item_state_381',
    match: '',
  },
  STATE_BID_RETURN_RECEIVED: {
    val: 382,
    front: 'portfolio_item_state_382',
    match: '',
  },
  STATE_BID_RETURN_COMPLETE: {
    val: 383,
    front: 'portfolio_item_state_383',
    match: '',
  },
  STATE_BID_REFUNDED: {
    val: 390,
    front: 'portfolio_item_state_390',
    match: '',
  },
  STATE_BID_REFUND_FAILED: {
    val: 391,
    front: 'portfolio_item_state_391',
    match: '',
  },
  STATE_BID_ADMIN_CANCELED: {
    val: 392,
    front: 'portfolio_item_state_392',
    match: '',
  },
  STATE_BID_FRAUDULENT: {
    val: 393,
    front: 'portfolio_item_state_393',
    match: '',
  },
  STATE_BID_RETURN_REJECTED: {
    val: 394,
    front: 'portfolio_item_state_394',
    match: '',
  },
  STATE_ASKING: {
    val: 400,
    front: 'portfolio_item_state_400',
    match: '',
    short: 'portfolio_item_state_400_short',
  },
  STATE_ASK_AUTHORIZATION_FAILED: {
    val: 409,
    front: 'portfolio_item_state_409',
    match: '',
    short: 'portfolio_item_state_409_short',
  },
  STATE_ASK_MATCHED_BID: {
    val: 410,
    front: 'portfolio_item_state_410',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_410_short',
  },
  STATE_ASK_FRAUD_REVIEW: {
    val: 411,
    front: 'portfolio_item_state_411',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_411_short',
  },
  STATE_ASK_SHIPPING_DELAY_EXPECTED: {
    val: 415,
    front: 'portfolio_item_state_415',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_415_short',
  },
  STATE_ASK_LABEL_PRINTED: {
    val: 418,
    front: 'portfolio_item_state_418',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_418_short',
  },
  STATE_TRADER_PURCHASE_REQUIRED: {
    val: 420,
    front: '',
    match: 'Waiting for Seller to Ship',
  },
  STATE_TRADER_PURCHASED: {
    val: 425,
    front: '',
    match: 'Waiting for Seller to Ship',
  },
  STATE_TRADER_PURCHASE_FAILED: {
    val: 426,
    front: '',
    match: 'Waiting for Seller to Ship',
  },
  STATE_ASK_SHIPPED_TO_AUTHENTICATOR: {
    val: 430,
    front: 'portfolio_item_state_430',
    match: '',
    short: 'portfolio_item_state_430_short',
  },
  STATE_ASK_AUTHENTICATOR_RECEIVED: {
    val: 440,
    front: 'portfolio_item_state_440',
    match: '',
    short: 'portfolio_item_state_440_short',
  },
  STATE_ASK_AUTHENTICATING: {
    val: 450,
    front: 'portfolio_item_state_450',
    match: '',
    short: 'portfolio_item_state_450_short',
  },
  STATE_ASK_AUTHENTICATION: {
    val: 455,
    front: 'portfolio_item_state_455',
    match: '',
    short: 'portfolio_item_state_455_short',
  },
  STATE_ASK_FUNDS_RELEASE_WAITING: {
    val: 458,
    front: 'portfolio_item_state_465',
    match: '',
    short: 'portfolio_item_state_465_short',
  },
  STATE_ASK_PAUSE_WAITING_PAYOUT: {
    val: 459,
    front: 'portfolio_item_state_465',
    match: '',
    short: 'portfolio_item_state_465_short',
  },
  STATE_ASK_FUNDS_RELEASED: {
    val: 460,
    front: 'portfolio_item_state_460',
    match: '',
    short: 'portfolio_item_state_460_short',
  },
  STATE_ASK_FUNDS_RELEASED_FAILED: {
    val: 465,
    front: 'portfolio_item_state_465',
    match: '',
    short: 'portfolio_item_state_465_short',
  },
  STATE_ASK_FROM_INVENTORY: {
    val: 470,
    front: 'portfolio_item_state_470',
    match: 'En Route to StockX',
    short: 'portfolio_item_state_470_short',
  },
  STATE_ASK_COMPLETE: {
    val: 480,
    front: 'portfolio_item_state_480',
    match: '',
    short: 'portfolio_item_state_480_short',
  },
  STATE_ASK_TEMPORARILY_SUSPENDED: {
    val: 489,
    front: 'portfolio_item_state_489',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_489_short',
  },
  STATE_ASK_AUTHENTICATION_FAILED: {
    val: 490,
    front: 'portfolio_item_state_490',
    match: '',
    short: 'portfolio_item_state_490_short',
  },
  STATE_ASK_MERCHANT_BACKED_OUT: {
    val: 491,
    front: 'portfolio_item_state_491',
    match: 'Waiting for Seller to Ship',
    short: 'portfolio_item_state_491_short',
  },
  STATE_ASK_ADMIN_CANCELED: {
    val: 492,
    front: 'portfolio_item_state_492',
    match: 'Purchase Canceled',
    short: 'portfolio_item_state_492_short',
  },
  STATE_ASK_RETURNED_TO_SENDER: {
    val: 493,
    front: 'portfolio_item_state_493',
    match: 'Authentication Failed',
    short: 'portfolio_item_state_493_short',
  },
  STATE_ASK_FRAUDULENT_BUYER: {
    val: 494,
    front: 'portfolio_item_state_494',
    match: 'Purchase Canceled',
    short: 'portfolio_item_state_494_short',
  },
};

export const updatableStates = [
  states.STATE_BIDDING.val,
  states.STATE_ASKING.val,
  states.STATE_BID_PAYMENT_FAILED.val,
  states.STATE_ASK_AUTHORIZATION_FAILED.val,
];

const upsStatusStates = [
  states.STATE_ASK_SHIPPED_TO_AUTHENTICATOR.val,
  states.STATE_ASK_SHIPPED_TO_AUTHENTICATOR.val,
  states.STATE_BID_SHIPPED_TO_BUYER.val,
];

export const shipByDateStates = [
  states.STATE_ASK_MATCHED_BID.val,
  states.STATE_ASK_FRAUD_REVIEW.val,
  states.STATE_ASK_LABEL_PRINTED.val,
];

export const printableStates = [
  states.STATE_ASK_MATCHED_BID.val,
  states.STATE_ASK_FRAUD_REVIEW.val,
  states.STATE_ASK_LABEL_PRINTED.val,
  states.STATE_ASK_SHIPPING_DELAY_EXPECTED.val,
];

export const cancelledStates = [
  states.STATE_ASK_AUTHENTICATION_FAILED.val,
  states.STATE_ASK_MERCHANT_BACKED_OUT.val,
  states.STATE_ASK_ADMIN_CANCELED.val,
];

export const sellingPendingStates = [
  409, 410, 411, 415, 418, 420, 425, 426, 430, 440, 450, 455, 458, 459, 460,
  465, 470, 489,
];

export const sellingHistoryStates = [480, 490, 491, 492, 493, 494];

const properties = {
  [states.STATE_ASK_COMPLETE.val]: {
    type: 'sales',
    className: 'allSales',
    leanplumEvt: 'ViewSalesClick',
  },

  [states.STATE_ASKING.val]: {
    type: 'asks',
    className: 'allAsks',
    title: 'All Asks',
    leanplumEvt: 'ViewAsksClick',
  },

  [states.STATE_BIDDING.val]: {
    type: 'bids',
    className: 'allBids',
    title: 'All Bids',
    leanplumEvt: 'ViewBidsClick',
  },
};

const actions = {
  PLACE_ORDER: 900,
  HOLD: 1000,
  WANT: 1001,
  BID: 1002,
  ASK: 1003,
  REMOVE: 1400,
  SHIP: 1204,
  ASK_SYSTEM_UNDO: 1220,
  ASK_PRINT_LABEL: 1241,
};

const notBidPaidStates = [
  states.STATE_ASK_COMPLETE.val,
  states.STATE_ASK_FUNDS_RELEASED.val,
  states.STATE_ASK_FUNDS_RELEASED_FAILED.val,
];

export const shippingStates = [
  states.STATE_ASK_MATCHED_BID.val,
  states.STATE_ASK_FRAUD_REVIEW.val,
  states.STATE_ASK_SHIPPING_DELAY_EXPECTED.val,
  states.STATE_ASK_LABEL_PRINTED.val,
];

const portfolioItemMessages = Object.values(states).reduce(
  (messageDict, state) => {
    messageDict[state.val] = state;
    return messageDict;
  },
  {},
);

export function getHuman(
  portfolioItem: PortfolioItem,
  t: TFunction,
  mobile = false,
) {
  const matchedState = portfolioItem?.matchedState;
  const state = portfolioItem?.state;
  const carrierCode = portfolioItem?.shipment?.carrierCode;

  let message;

  if (state === 320 && !notBidPaidStates.includes(matchedState)) {
    message = portfolioItemMessages[matchedState].match
      ? t(portfolioItemMessages[matchedState].match)
      : t(portfolioItemMessages[matchedState].front);
  }

  if (state === 418) {
    message = carrierCode
      ? t(portfolioItemMessages[state]?.front, {
          carrier: getCarrier(carrierCode).name,
        })
      : t(portfolioItemMessages[state]?.short);
  }

  if (mobile && portfolioItemMessages[state]?.short) {
    message = t(portfolioItemMessages[state]?.short);
  }

  if (
    state === 339 &&
    !isDatePassed(addDays(new Date(portfolioItem?.createdAt), 3))
  ) {
    return t('authenticated_carrier_pickup_delay');
  }

  if (message) {
    return message;
  }

  return portfolioItemMessages[state]?.front
    ? t(portfolioItemMessages[state]?.front)
    : t('Unknown');
}

const portfolioItem = {
  states,
  updatableStates,
  upsStatusStates,
  shipByDateStates,
  actions,
  getHuman,
  properties,
};

export default portfolioItem;
